import { render } from "./AirportTicketDetailModal.vue?vue&type=template&id=1d5c8778&scoped=true"
import script from "./AirportTicketDetailModal.vue?vue&type=script&lang=js"
export * from "./AirportTicketDetailModal.vue?vue&type=script&lang=js"

import "./AirportTicketDetailModal.vue?vue&type=style&index=0&id=1d5c8778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5c8778"]])

export default __exports__